import React, { PropsWithChildren } from 'react';

type PageLeadPageTypeDefinitionProps = {
  type: string;
};

export function PageLeadPageTypeDefinition({ type, children }: PropsWithChildren<PageLeadPageTypeDefinitionProps>) {
  return (
    <p className="invisible">
      <dfn>{type}: </dfn>
      {children}
    </p>
  );
}
